export default __webpack_public_path__ + "static/media/truck-01.aa98421b.jpg";